import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiSearchAlt2 } from "react-icons/bi";
import { GrAddCircle, GrEdit } from "react-icons/gr";
import { Button, Input, Table } from "reactstrap";
import { RiDeleteBin6Line } from "react-icons/ri";
import { getData } from "../../../api/method";
import Pagination from "../../pagination";

function TableCustomers({
  args,
  toggleAdd,
  getCustomerByEdit,
  getCustomerByDel,
}) {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);

  const getCustomer = async () => {
    try {
      const result = await getData("/api/User");
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCustomer();
  }, [data]);

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(12);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div className="d-flex align-items-center line_border--admin">
        <BiSearchAlt2 className="t-grey ms-2" />

        <Input
          className="border-0"
          placeholder="Enter you keyword..."
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="pt-4">
        <div className="d-flex justify-content-between pb-4">
          <Button
            className="btn_add fs-20 d-flex align-items-center"
            onClick={toggleAdd}
          >
            <GrAddCircle className="me-2" />
            Add
          </Button>
        </div>

        <Table className="table_admin">
          <thead>
            <tr className="fw-bold">
              <th className="table_ct_stt">#</th>
              <th className="table_ct_user">Usename</th>
              <th className="table_ct_name">Fullname</th>
              <th className="table_ct_phone">Phone</th>
              <th className="table_ct_email">Email</th>
              <th className="table_ct_date">Date</th>
              <th className="table_ct_active">Active</th>
              <th className="" colSpan={2}></th>
            </tr>
          </thead>
          <tbody>
            {currentData
              ?.filter((item) => {
                if (search === "") {
                  return item;
                } else if (
                  item.username.toLowerCase().includes(search.toLowerCase()) ||
                  item.firstname.toLowerCase().includes(search.toLowerCase()) ||
                  item.lastname.toLowerCase().includes(search.toLowerCase())
                ) {
                  return item;
                }
              })
              .map((item, index) => (
                <tr key={index}>
                  <td className="table_ct_stt">{index}</td>
                  <td className="table_ct_user">{item.username}</td>
                  <td className="table_ct_name t-capitalize">
                    {item.lastname} {item.firstname}
                  </td>
                  <td className="table_ct_phone">{item.phone}</td>
                  <td className="table_ct_email">{item.email}</td>
                  <td className="table_ct_date">{item.created.slice(0, 10)}</td>
                  <td
                    className={`table_ct_active ${
                      item.actived === 1 ? "t-red" : ""
                    }`}
                  >
                    {item.actived === 1 ? "Active" : "Block"}
                  </td>
                  <td
                    className="table_ct_act cursor_pointer"
                    onClick={() => getCustomerByEdit(item.username)}
                  >
                    <GrEdit className="fs-4" />
                  </td>
                  <td
                    className="table_ct_act cursor_pointer"
                    onClick={() => getCustomerByDel(item.id)}
                  >
                    <RiDeleteBin6Line className="fs-4" />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>

        <Pagination
          paginate={paginate}
          postsPerPage={dataPerPage}
          totalPosts={data.length}
        />
      </div>
    </div>
  );
}

export default TableCustomers;
